import {createFeatureSelector, createSelector} from '@ngrx/store';
import { ProviderConnectivityState, providerConnectivityFeatureKey } from './provider-connectivity.reducer';
import _ from 'lodash'; 

const selectProviderConnectivityState = createFeatureSelector<ProviderConnectivityState>(providerConnectivityFeatureKey);

export const selectProviderConnectivityForm = createSelector(
    selectProviderConnectivityState,
    state => ({...state, data: _.cloneDeep(state.data)}) // Désactive l'immutabilité des data. Ce qui permettra de les modifier dans les composants
);
